import React from "react";
import AdminHamburgerMenu from "../SuperAdmin/AdminHamburgerMenu";

function HamburgerAdmin() {

  return <AdminHamburgerMenu />;
}

export default HamburgerAdmin;
